import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { MilestoneTypes } from './actionTypes';
import {
    getMilestonesSuccess,
    getMilestonesFail,
    updateMilestonesFail,
    getMilestonOperationDataSuccess,
    getMilestonOperationDataFail,

    getMilestonesLifeEventsSuccess,
    getMilestonesLifeEventsFail,
    addMilestonesLifeEventsSuccess,
    addMilestonesLifeEventsFail

} from './actions';

import apiFetch from '../../fetch';
import * as url from '../../helpers/url_helper';

export const fetchMilestones = async () => {
    const Operations = [
        {
            id: 1,
            OperationType: 'SO',
            OperationName: 'Sales Order List',
        },
        {
            id: 2,
            OperationType: 'PO',
            OperationName: 'Purchase Order List',
        },
        {
            id: 3,
            OperationType: 'WH',
            OperationName: 'Wharehouse Receipt List',
        },
        {
            id: 4,
            OperationType: 'CR',
            OperationName: 'Cargo Release List',
        },
        {
            id: 6,
            OperationType: 'WI',
            OperationName: 'Commodity List',
        },
        {
            id: 7,
            OperationType: 'IEN',
            OperationName: 'Entities List',
        },
        {
            id: 8,
            OperationType: 'SH',
            OperationName: 'Shipments List',
        },
        {
            id: 9,
            OperationType: 'PK',
            OperationName: 'Pickup Order List',
        },
        {
            id: 10,
            OperationType: 'IV',
            OperationName: 'Item Definitions',
        },
        {
            id: 11,
            OperationType: 'IN',
            OperationName: 'Invoices',
        },
        {
            id: 12,
            OperationType: 'QT',
            OperationName: 'Quotation List',
        },
        {
            id: 13,
            OperationType: 'BK',
            OperationName: 'Booking List',
        },
    ];
    return Operations;
};

export const fetchMilestonesOperationDataSO = async ({ payload: { Operation } }: any) => {
    const { OperationType } = Operation;

    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query{
    GetLastSalesOrdersByOperationType(SalesOrders: {
      userId: ${user.id || ''},
    } ){
      milestoneConfig {
        OperationType
        OperationName
        userId
        text
        dataField
        visibleInTable
        visibleInModalHeader
        visibleInMiddle
        visibleInModalFooter
        isMilestone          
        visibleInModalBody
        visibleInModalTotal
        showInFilters
        order
        hidden
      }

      salesOrdersData {
        id
        Number
        Status
        ShippingDate
        BuyerName
        CreatedByName
        SellerName
        BillingClientName
        PaymentTerms
        ExchangeRate
        CreatorNetworkID
        TotalPieces
        TotalAmountInCurrency
        IsAcceptedBySeller
        IsOnline
        IsCancelled
        CFstatus_gwae
        CFwh_location
        CFbrand
        CFcommodity_type
        CreatedOn
        ApprovedByName
        Notes
        ReferenceNumber
        AreaPrecision
        DbClassType
        DocumentTemplateName
        IsOnlineTransaction
        IsTrackingEmailSent  
        LastLineID  
        LengthPrecision
        LengthUnit      
        VolumePrecision  
        VolumeUnit 
        VolumeWeightPrecision
        WeightPrecision  
        WeightUnit

        GUID
        customFields {
          name
          value
          internalName
        }
      }
    }
  }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    const arr = response?.data.GetLastSalesOrdersByOperationType.salesOrdersData;
    const result = arr.filter((foundItem: { customFields: [] }) => {
        if (foundItem.customFields.length > 0) {
            return foundItem;
        }
    });

    const data = result.length !== 0 ? result : arr.length !== 0 ? [arr[0]] : [];

    const tmpPayload = {
        data,
        milestoneConfig: response.data.GetLastSalesOrdersByOperationType.milestoneConfig,
    };
    return tmpPayload;
};
export const fetchMilestonesOperationDataSH = async () => {
    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query{
    GetLastShipmentsByOperationType(Shipments: {
      userId: ${user.id || ''},
    } ){
      milestoneConfig {
      OperationType
      OperationName
      userId
      text
      dataField
      visibleInTable
      visibleInModalHeader
      visibleInMiddle
      visibleInModalFooter
      isMilestone
      visibleInModalBody
      visibleInModalTotal
      showInFilters
      order
      hidden
    }

    shipmentsData {
      Number
      id
      clientId
      Int
      AESITNInt
      AESStatus
      AESXTNInt
      AMSActionCode
      AMSNotifyParty1Name
      AMSNotifyParty1SCAC
      AMSNotifyParty2Name
      AMSNotifyParty2SCAC
      AgentPartType
      AirWaybillTotalsInKg
      AirWaybillWeightUnit
      AreShipperConsigneeRelated
      AreaPrecision
      Barcodes
      BillOfLadingGroupSimilarItems
      BillOfLadingWeightUnit
      BookingInt
      CargoStorage
      CarrierName
      ConsigneeName
      CreatedByName
      CreatedOn
      CreatorNetworkID
      CutoffDate
      DbClassType
      DeclaredValue
      DeliveryAgentName
      DescriptionOfGoods
      DestinationAgentName
      DestinationPickupEntityName
      DestinationPortSchedule
      Direction
      DoNotUseAgent
      DocumentTemplateName
      EntryInt
      EstimatedArrivalDate
      EstimatedDepartureDate
      ExecutedCityCode
      ExecutedPlace
      FillDocsWithAccountingInfo
      Flags
      GUID
      GenerateCommissionsAsExpenses
      GenerateOneTransactionPerEntity
      GroupChargesInLiquidation
      HasGlobalAgentParticipation
      HasGlobalSalesManParticipation
      InsuranceInt
      IntermediateConsigneeName
      IsAirWayBillDetailExpanded
      IsBillOfLadingDetailExpanded
      IsCargoManifestDetailExpanded
      IsFullContainerLoad
      IsRoutedTransaction
      IsTrackingEmailSent
      IssuedByName
      LastDateOfDeparture
      LastPortOfDepartureSchedule
      LengthPrecision
      LengthUnit
      ManifestInt
      MasterGUID
      MaximumPieces
      ModeOfTransportCode
      Notes
      NotifyPartyName
      OceanCarriersInterfaceMessageVersion
      OriginPortSchedule
      PickupDate
      ProfitOrder
      ReceivedAtNetworkID
      RoutingInstructions
      SalesManPartType
      Service
      ShipperName
      ShowContainerDetails
      ShowDetailsInLiquidation
      ShowDimensionsDetailedInAWB
      ShowDimensionsInAWB
      ShowWHRsInCargoManifest
      SmartBorderInt
      SplitTaxedFromNonTaxedTransactions
      SpottingDate
      Status
      TotalPieces
      TotalVolume
      TotalVolumeWeight
      TotalWeight
      Type
      UseNotesAsMarksIntsInBL
      Version
      VolumePrecision
      VolumeUnit
      VolumeWeightPrecision
      WaybillNotes
      WeightPrecision
      WeightUnit
      DelPort_CodeCity
      DelPort_CodeCountry
      DelPort_City
      DelPort_Country
      DelPort_Notes
      DelPort_DbClassType
      DestPort_CodeCity
      DestPort_CodeCountry
      DestPort_Method
      DestPort_City
      DestPort_Country
      DestPort_Notes
      DestPort_DbClassType
      LastPortDep_CodeCity
      LastPortDep_CodeCountry
      LastPortDep_City
      LastPortDep_Country
      LastPortDep_Notes
      LastPortDep_DbClassType
      LastPortDep_Method
      OrigPort_CodeCity
      OrigPort_CodeCountry
      OrigPort_City
      OrigPort_Country
      OrigPort_Notes
      OrigPort_DbClassType
      RecPort_City
      RecPort_CodeCity
      RecPort_CodeCountry
      RecPort_Country
      RecPort_Notes
      RecPort_DbClassType
      TypeShipment
      VesselName
      VesselFlagCode
      VoyageIdentification
      AirWayBillNumber
      FlightNumber
      BillOfLadingNumber
      CarrierTrakingNumber
      CarrierPRONumber
      BillingClientName
      ModeOfTransport_Code
      ModeOfTransport_DbClassType
      ModeOfTransport_Description
      ModeOfTransport_Flags
      ModeOfTransport_IsContainerized
      ModeOfTransport_Method
      ModeOfTransport_Status
      Division_GUID
      Division_Name
      LayoutType
      VolumeWeightUnit
      AreaUnit
      VolumeWeightFactor
      BookingNumber
      Item {
        Pieces
        PackageName
        Description
        IsContainer
        ItemGuid
      }
      customFields {
        id
        value
        clientId
        OperationNumber
        name
        internalName
        OperationType
        OperationGUID
        createdAt
        updatedAt
      }
    }
    }
  }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    const arr = response?.data.GetLastShipmentsByOperationType.shipmentsData;

    const result = arr.filter((foundItem: { customFields: [] }) => {
        if (foundItem.customFields.length > 0) {
            return foundItem;
        }
    });

    const data = result.length !== 0 ? result : arr.length !== 0 ? [arr[0]] : [];

    const tmpPayload = {
        data,
        milestoneConfig: response.data.GetLastShipmentsByOperationType.milestoneConfig,
    };

    return tmpPayload;
};

export const fetchMilestonesOperationDataPK = async () => {
    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query{
    GetLastPickupOrderByOperationType(PickupOrders: {
      userId: ${user.id || ''},
    } ){
      milestoneConfig {
      OperationType
      OperationName
      userId
      text
      dataField
      visibleInTable
      visibleInModalHeader
      visibleInMiddle
      visibleInModalFooter
      isMilestone
      visibleInModalBody
      visibleInModalTotal
      showInFilters
      order
      hidden
    }
    pickupOrdersData {
        id
        initial_date
        final_date
        order
        Number
        clientId
        GUID
        BillingClientName
        CreatedOn
        AreaPrecision
        BondedEntryDate
        BondedWarehouseNumber
        BondedWarehouseType
        CarrierBookingNumber
        CarrierName
        CarrierPRONumber
        CarrierTrackingNumber
        ConsigneeName
        CreatedBy
        CreatorNetworkID
        DbClassType
        DeliveryDate
        DeliveryEntityName
        DestinationAgentName
        DocumentTemplateName
        DriverLicenseNumber
        DriverName
        IsOnlineTransaction
        IsTrackingEmailSent
        IssuedByName
        LastItemID
        LengthPrecision
        LengthUnit
        ModeOfTransportCode
        Notes
        PickupDate
        PickupEntityName
        ShipperName
        Status
        SupplierInvoiceNumber
        SupplierName
        SupplierPONumber
        TotalPieces
        Type
        Version
        VolumePrecision
        VolumeUnit
        VolumeWeightPrecision
        WeightPrecision
        WeightUnit
        customFields {
            id
            value
            clientId
            OperationNumber
            name
            internalName
            OperationType
            OperationGUID
            createdAt
            updatedAt
        }
      }
    }
}`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    const arr = response?.data.GetLastPickupOrderByOperationType.pickupOrdersData;

    const result = arr.filter((foundItem: { customFields: [] }) => {
        if (foundItem.customFields.length > 0) {
            return foundItem;
        }
    });

    const data = result.length !== 0 ? result : arr.length !== 0 ? [arr[0]] : [];

    const tmpPayload = {
        data,
        milestoneConfig: response.data.GetLastPickupOrderByOperationType.milestoneConfig,
    };

    return tmpPayload;
};

export const fetchMilestonesOperationDataPO = async ({ payload: { Operation } }: any) => {
    const { OperationType } = Operation;

    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query{
    GetLastPurchaseOrdersByOperationType(PurchaseOrders: {
      userId: ${user.id || ''},
    } ){
      milestoneConfig {
        OperationType
        OperationName
        userId
        text
        dataField
        visibleInTable
        visibleInModalHeader
        visibleInMiddle
        visibleInModalFooter
        isMilestone          
        visibleInModalBody
        visibleInModalTotal
        showInFilters
        order
        hidden
      }

      purchaseOrdersData {
        id
        initial_date
        final_date
        clientId
        Number 
        CreatedOn
        CreatedByName
        Version
        Status
        BuyerName
        SellerName
        BillingClientName
        TotalAmountInCurrency
        ItemsAmountInCurrency 
        ChargesAmountInCurrency
        TaxAmountInCurrency
        TotalAmount
        ItemsAmount
        ChargesAmount 
        TaxAmount
        TotalWeight
        TotalVolume
        TotalTradeDiscount
        TotalTradeDiscountInCurrency
        ExchangeRate
        CreatorNetworkID
        TotalPieces
        IsAcceptedBySeller
        IsOnline
        IsCancelled
        ApprovedByName
        DocumentTemplateName
        Notes
        PaymentTerms
        ReferenceNumber
        IsOnlineTransaction    
        IsTrackingEmailSent          
        LastLineID
        LengthPrecision    
        LengthUnit    
        VolumePrecision      
        VolumeUnit      
        VolumeWeightPrecision        
        WeightPrecision    
        WeightUnit
        JOBNumber
        GUID
        customFields {
          name
          value
          internalName
        }
      }
    }
  }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    const arrPurchase = response?.data.GetLastPurchaseOrdersByOperationType.purchaseOrdersData;
    const result = arrPurchase.filter((foundItem: { customFields: [] }) => {
        if (foundItem.customFields.length > 0) {
            return foundItem;
        }
    });

    const data = result.length !== 0 ? result : arrPurchase.length !== 0 ? [arrPurchase[0]] : [];

    const tmpPayload = {
        data,
        milestoneConfig: response.data.GetLastPurchaseOrdersByOperationType.milestoneConfig,
    };
    return tmpPayload;
};

export const fetchMilestonesOperationDataWR = async ({ payload: { Operation } }: any) => {
    const { OperationType } = Operation;

    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query{
    GetLastWhareHouseReceiptsByOperationType(WareHouseReceipt: {
      userId: ${user.id || ''},
    } ){
      milestoneConfig {
        OperationType
        OperationName
        userId
        text
        dataField
        visibleInTable
        visibleInModalHeader
        visibleInMiddle
        visibleInModalFooter
        isMilestone          
        visibleInModalBody
        visibleInModalTotal
        showInFilters
        order
        hidden
      }

      wharehouseReceiptData {
        id
        clientId
        CreatedOn
        Number
        CreatedByName
        BillingClientName
        Version
        ModeOfTransportCode
        IssuedByName
        ShipperName
        ConsigneeName
        CreatorNetworkID
        TotalPieces
        TotalWeight
        TotalVolume
        TotalVolumeWeight
        ChargeableWeight
        TotalValue
        Status
        HasAttachments
        LastItemID
        IsOnline
        IsLiquidated
        AreaPrecision  
        BondedWarehouseType
        DbClassType
        IsOnlineTransaction
        IsTrackingEmailSent
        LengthPrecision
        LengthUnit
        Type
        VolumePrecision
        VolumeUnit
        VolumeWeightPrecision
        WeightPrecision
        WeightUnit
        VolumeWeightFactor
        BondedWarehouseNumber
        CarrierBookingNumber
        CarrierName
        CarrierPRONumber
        CarrierTrackingNumber
        CreatedBy
        DocumentTemplateName
        DriverLicenseNumber
        DriverName
        Notes
        SupplierInvoiceNumber
        SupplierName
        SupplierPONumber
        DestinationAgentName
        GUID
        customFields {
          name
          value
          internalName
        }
      }
    }
  }`;
    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    const arr = response?.data.GetLastWhareHouseReceiptsByOperationType.wharehouseReceiptData;
    const result = arr.filter((foundItem: { customFields: [] }) => {
        if (foundItem.customFields.length > 0) {
            return foundItem;
        }
    });

    const data = result.length !== 0 ? result : arr.length !== 0 ? [arr[0]] : [];

    const tmpPayload = {
        data,
        milestoneConfig: response.data.GetLastWhareHouseReceiptsByOperationType.milestoneConfig,
    };
    return tmpPayload;
};

export const fetchMilestonesOperationDataCR = async ({ payload: { Operation } }: any) => {
    const { OperationType } = Operation;

    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query{
    GetLastCargoReleaseByOperationType(CargoReleases: {
      userId: ${user.id || ''},
    } ){
      milestoneConfig {
        OperationType
        OperationName
        userId
        text
        dataField
        visibleInTable
        visibleInModalHeader
        visibleInMiddle
        visibleInModalFooter
        isMilestone          
        visibleInModalBody
        visibleInModalTotal
        showInFilters
        order
        hidden
      }

      cargoReleasesData {
        id
        clientId
        CreatedOn
        ReleaseDate
        Number
        BillingClientName
        CreatedByName
        Version    
        IssuedByName    
        CreatorNetworkID
        TotalPieces
        TotalWeight
        TotalVolume
        TotalVolumeWeight    
        TotalValue
        ReleasedToName
        Status
        HasAttachments    
        IsOnline
        IsLiquidated    
        CFaverage_days_to_prepare
        CFaverage_days_to_release
        CFwh_location
        CFcr_cartons
        CFcr_pallets
        AreaPrecision
        CargoStorageID
        DbClassType
        IsOnlineTransaction
        IsTrackingEmailSent
        LengthPrecision
        LengthUnit
        VolumePrecision
        VolumeUnit
        VolumeWeightPrecision
        WeightPrecision
        WeightUnit
        Barcodes       
        CarrierName       
        CarrierPRONumber
        CarrierTrackingNumber
        DocumentTemplateName
        DriverLicenseNumber
        DriverName 
        Notes
        SupplierPONumber 

        GUID
        customFields {
          name
          value
          internalName
        }
      }
    }
  }`;
    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    const arr = response?.data.GetLastCargoReleaseByOperationType.cargoReleasesData;
    const result = arr.filter((foundItem: { customFields: [] }) => {
        if (foundItem.customFields.length > 0) {
            return foundItem;
        }
    });

    const data = result.length !== 0 ? result : arr.length !== 0 ? [arr[0]] : [];

    const tmpPayload = {
        data,
        milestoneConfig: response.data.GetLastCargoReleaseByOperationType.milestoneConfig,
    };
    return tmpPayload;
};

export const fetchMilestonesOperationDataWI = async ({ payload: { Operation } }: any) => {
    const { OperationType } = Operation;

    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query {
  GetLastComodityListByOperationType(Comodity:{
    userId: ${user.id || ''},
  }) {
    milestoneConfig {
      OperationType
      OperationName
      userId
      text
      dataField
      visibleInTable
      visibleInModalHeader
      visibleInMiddle
      visibleInModalFooter
      isMilestone
      visibleInModalBody
      visibleInModalTotal
      showInFilters
      order
      hidden
    }
    comodityData {
      CRclientId
      CRCreatedOn
      CRReleaseDate
      CRNumber
      CRCreatedByName
      CRVersion
      CRIssuedByName
      CRCreatorNetworkID
      CRTotalPieces
      CRTotalWeight
      CRTotalVolume
      CRTotalVolumeWeight
      CRTotalValue
      CRReleasedToName
      CRStatus
      CRHasAttachments
      CRIsOnline
      CRIsLiquidated
      CRCFaverage_days_to_prepare
      CRCFaverage_days_to_release
      CRCFwh_location
      CRCFcr_cartons
      CRCFcr_pallets
      CRGUID
      CRBillingClientName
      CRBillingClientGUID
      CRReleasedToGUID
      CRcustomFields {
        name
        value
        internalName
      }
      PONumber
      POCreatedOn
      POCreatedByName
      POVersion
      POStatus
      POBuyerName
      POSellerName
      POTotalAmountInCurrency
      POItemsAmountInCurrency
      POChargesAmountInCurrency
      POTaxAmountInCurrency
      POTotalAmount
      POItemsAmount
      POChargesAmount
      POTaxAmount
      POTotalWeight
      POTotalVolume
      POTotalTradeDiscount
      POTotalTradeDiscountInCurrency
      POExchangeRate
      POCreatorNetworkID
      POTotalPieces
      POIsAcceptedBySeller
      POIsOnline
      POIsCancelled
      POGUID
      POCFstatus_gwae
      POCFbrand
      POCFcommodity_type
      POcreatedAt
      POupdatedAt
      POBillingClientName
      POBillingClientGUID
      POBuyerGUID
      POSellerGUID
      POApprovedByName
      PODocumentTemplateName
      PONotes
      POPaymentTerms
      POReferenceNumber
      POIsOnlineTransaction
      POIsTrackingEmailSent
      POLastLineID
      POLengthPrecision
      POLengthUnit
      POVolumePrecision
      POVolumeUnit
      POVolumeWeightPrecision
      POWeightPrecision
      POWeightUnit
      POJOBNumber
      POcustomFields {
        name
        value
        internalName
      }
      WRclientId
      WRCreatedOn
      WRNumber
      WRCreatedByName
      WRVersion
      WRModeOfTransportCode
      WRIssuedByName
      WRShipperName
      WRConsigneeName
      WRCreatorNetworkID
      WRTotalPieces
      WRTotalWeight
      WRTotalVolume
      WRTotalVolumeWeight
      WRChargeableWeight
      WRTotalValue
      WRStatus
      WRHasAttachments
      WRLastItemID
      WRIsOnline
      WRIsLiquidated
      WRGUID
      WRCFstatus_gwae
      WRCFwh_location
      WRcreatedAt
      WRupdatedAt
      WRBillingClientName
      WRBillingClientGUID
      WRDestinationAgentName
      WRcustomFields {
        name
        value
        internalName
      }
      clientId
      CLVersion
      CLStatus
      CLWarehouseReceiptGUID
      CLCargoReleaseGUID
      CLPackageName
      CLLocationCode
      CLWarehouseReceiptNumber
      CLCargoReleaseNumber
      CLOutDate
      CLPieces
      CLPieceQuantity
      CLWHRItemID
      CLOrderIndex
      CLContainedPiecesWeightIncluded
      CLIsContainer
      CLIsSummarized
      CLIncludeInSED
      CLIsPallet
      CLIsOverstock
      CLNotLoaded
      CLInTask
      CLDescription
      CLPartNumber
      CLUpItemGUID
      CLOutShipmentGUID
      CLOutMasterWayBillNumber
      CLOutHouseWayBillNumber
      CLLastReceptionNetworkID
      CLShipmentType
      CLSupplierPONumber
      CLPurchaseOrderGUID
      CLSalesOrderGUID
      CLSOLineID
      CLSalesOrderNumber
      CLEntryDate
      CLGUID
      CLcreatedAt
      CLupdatedAt
      CLExpirationDate
      CLLotNumber
      CLPickupOrderGUID
      CLInShipmentGUID
      CLInshipmentNumber
      CLOutShipmentNumber
      CLInMasterShipmentGUID
      CLOutMasterShipmentGUID
      CLWArehouse
      CLmodel
      CLLengthUnit
      CLHeightUnit
      CLWidthUnit
      CLWeightUnit
      CLVolumeUnit
      CLVolumeWeightUnit
      CLLength
      CLHeight
      CLWidth
      CLWeight
      CLVolume
      CLVolumeWeight
     CLBookingNumber
     CLBookingGUID
     CLQuotationNumber
     CLQuotationGUID
      SOclientId
      SONumber
      SOCreatedOn
      SOCreatedByName
      SOVersion
      SOStatus
      SOShippingDate
      SOBuyerName
      SOSellerName
      SOPaymentTerms
      SOExchangeRate
      SOCreatorNetworkID
      SOTotalPieces
      SOTotalAmountInCurrency
      SOIsAcceptedBySeller
      SOIsOnline
      SOIsCancelled
      SOCFstatus_gwae
      SOCFwh_location
      SOCFbrand
      SOCFcommodity_type
      SOGUID
      SOcreatedAt
      SOupdatedAt
      SOBillingClientName
      SOBillingClientGUID
      SOBuyerGUID
      SOSellerGUID
      SOcustomFields {
        name
        value
        internalName
      }
      IPKclientId
      IPKNumber
      IPKGUID
      IPKCreatedOn
      IPKLogDate
      IPKAreaPrecision
      IPKBondedEntryDate
      IPKBondedWarehouseNumber
      IPKBondedWarehouseType
      IPKCarrierBookingNumber
      IPKCarrierName
      IPKCarrierPRONumber
      IPKCarrierTrackingNumber
      IPKConsigneeName
      IPKCreatedBy
      IPKCreatorNetworkID
      IPKDbClassType
      IPKDeliveryDate
      IPKDeliveryEntityName
      IPKDestinationAgentName
      IPKDocumentTemplateName
      IPKDriverLicenseNumber
      IPKDriverName
      IPKIsOnlineTransaction
      IPKIsTrackingEmailSent
      IPKIssuedByName
      IPKLastItemID
      IPKLengthPrecision
      IPKLengthUnit
      IPKModeOfTransportCode
      IPKNotes
      IPKPickupDate
      IPKPickupEntityName
      IPKShipperName
      IPKStatus
      IPKSupplierInvoiceNumber
      IPKSupplierName
      IPKSupplierPONumber
      IPKTotalPieces
      IPKType
      IPKVersion
      IPKVolumePrecision
      IPKVolumeUnit
      IPKVolumeWeightPrecision
      IPKWeightPrecision
      IPKWeightUnit
      IPKcustomFields {
        name
        value
        internalName
      }
      SHclientId
      SHNumber
      SHAESITNNumber
      SHAESStatus
      SHAESXTNNumber
      SHAMSActionCode
      SHAMSNotifyParty1Name
      SHAMSNotifyParty1SCAC
      SHAMSNotifyParty2Name
      SHAMSNotifyParty2SCAC
      SHAgentPartType
      SHAESActionDate
      SHAirWaybillTotalsInKg
      SHAirWaybillWeightUnit
      SHAreaPrecision
      SHBarcodes
      SHBillOfLadingGroupSimi
      SHBillOfLadingWeightUni
      SHBookingNumber
      SHCargoStorage
      SHCarrierName
      SHConsigneeName
      SHCreatedByName
      SHCreatedOn
      SHLogDate
      SHCreatorNetworkID
      SHCutoffDate
      SHDbClassType
      SHDeclaredValue
      SHDeliveryAgentName
      SHDescriptionOfGoods
      SHDestinationAgentName
      SHDestinationPickupEnti
      SHDestinationPortSchedu
      SHDirection
      SHDoNotUseAgent
      SHDocumentTemplateName
      SHEntryNumber
      SHEstimatedArrivalDate
      SHEstimatedDepartureDat
      SHExecutedCityCode
      SHExecutedPlace
      SHFillDocsWithAccountin
      SHFlags
      SHGUID
      SHGenerateCommissionsAs
      SHGenerateOneTransactionPerEntity
      SHGroupChargesInLiquida
      SHHasGlobalAgentPartici
      SHHasGlobalSalesManPart
      SHInsuranceNumber
      SHIsAirWayBillDetailExp
      SHIsBillOfLadingDetailE
      SHIsCargoManifestDetail
      SHIsFullContainerLoad
      SHIsRoutedTransaction
      SHIsTrackingEmailSent
      SHIssuedByName
      SHLastDateOfDeparture
      SHLastPortOfDepartureSc
      SHLengthPrecision
      SHLengthUnit
      SHManifestNumber
      SHMasterGUID
      SHMaximumPieces
      SHModeOfTransportCode
      SHNotes
      SHNotifyPartyName
      SHOceanCarriersInterfaceMessageVersion
      SHOriginPortSchedule
      SHPickupDate
      SHProfitOrder
      SHReceivedAtNetworkID
      SHRoutingInstructions
      SHSalesManPartType
      SHService
      SHShipperName
      SHShowContainerDetails
      SHShowDetailsInLiquidat
      SHShowDimensionsInAWB
      SHShowWHRsInCargoManife
      SHSmartBorderNumber
      SHSpottingDate
      SHStatus
      SHTotalPieces
      SHTotalVolume
      SHTotalVolumeWeight
      SHTotalWeight
      SHType
      SHVersion
      SHVolumePrecision
      SHVolumeUnit
      SHVolumeWeightPrecision
      SHWaybillNotes
      SHWeightPrecision
      SHWeightUnit
      SHDelPort_CodeCity
      SHDelPort_CodeCountry
      SHDelPort_Method
      SHDelPort_City
      SHDelPort_Country
      SHDelPort_Notes
      SHDelPort_DbClassType
      SHDestPort_CodeCity
      SHDestPort_CodeCountry
      SHDestPort_Method
      SHDestPort_City
      SHDestPort_Country
      SHDestPort_Notes
      SHDestPort_DbClassType
      SHLastPortDep_CodeCity
      SHLastPortDep_CodeCoun
      SHLastPortDep_Method
      SHLastPortDep_City
      SHLastPortDep_Country
      SHLastPortDep_Notes
      SHLastPortDep_DbClassTy
      SHOrigPort_CodeCity
      SHOrigPort_CodeCountry
      SHOrigPort_Method
      SHOrigPort_City
      SHOrigPort_Country
      SHOrigPort_Notes
      SHOrigPort_DbClassType
      SHRecPort_CodeCity
      SHRecPort_CodeCountry
      SHRecPort_Method
      SHRecPort_City
      SHRecPort_Country
      SHRecPort_Notes
      SHRecPort_DbClassType
      SHTypeShipment
      SHVesselName
      SHVesselFlagCode
      SHVoyageIdentification
      SHAirWayBillNumber
      SHFlightNumber
      SHBillOfLadingNumber
      SHCarrierTrakingNumber
      SHCarrierPRONumber
      SHAreShipperConsigneeRe
      SHIntermediateConsignee
      SHShowDimensionsDetaile
      SHSplitTaxedFromNonTaxeas
      SHUseNotesAsMarksNumber
      SHBillingClientName
    	SHModeOfTransport_Code
    	SHModeOfTransport_DbClassType
    	SHModeOfTransport_Description
    	SHModeOfTransport_IsContainerized
    	SHModeOfTransport_Method
    	SHModeOfTransport_Status
    	SHDivision_GUID
    	SHDivision_Name
    	SHLayoutType
      SHcustomFields {
        name
        value
        internalName
      }

        BKclientId
        BKGUID
        BKNumber
        BKURL
        BKCreatedOn
        BKCreatedByName
        BKVersion
        BKModeOfTransportCode
        BKModeOfTransportDescription
        BKIssuedByName
        BKIssuedByGUID
        BKShipperName
        BKShipperGUID
        BKConsigneeName
        BKConsigneeGUID
        BKImporterName
        BKImporterGUID
        BKBillingClientName
        BKBillingClientGUID
        BKDeliverToEntityName
        BKDeliverToEntityGUID
        BKOriginPortCode
        BKOriginPortName
        BKOriginCountryCode
        BKDestinationPortCode
        BKDestinationPortName
        BKDestinationCountryCode
        BKDirection
        BKService
        BKBookingStatus
        BKIsLessThanFullLoad
        BKIsOnlineBooking
        BKIsOnline
        BKIsLiquidated
        BKExecutedPlace
        BKCustomerReferenceNumber
        BKEstimatedArrivalDate
        BKEstimatedDepartureDate
        BKLastDateOfDeparture
        BKSpottingDate
        BKPickupDate
        BKCutoffDate
        BKTotalPieces
        BKChargeableWeight
        BKTotalWeight
        BKTotalVolume
        BKTotalVolumeWeight
        BKTotalValue
        BKWeightUnit
        BKVolumeUnit
        BKVolumeWeightUnit
        BKCurrencyCode
        BKCreatorNetworkID
        BKLengthUnit
        BKLengthPrecision
        BKVolumePrecision
        BKWeightPrecision
        BKVolumeWeightPrecision
        BKAreaPrecision
        BKVolumeWeightFactor
        BKHasFiles

        BKcustomFields {
            name
            value
            internalName
        }


        QTclientId
        QTGUID
        QTNumber
        QTURL
        QTCreatedOn
        QTLogDate
        QTExpirationDate
        QTCreatedByName
        QTVersion
        QTIssuedByName
        QTIssuedByGUID
        QTContactName
        QTContactGUID
        QTStatus
        QTDirection
        QTService
        QTFrequency
        QTIsHazardous
        QTIsOpenQuote
        QTPaymentTerms
        QTExchangeRate
        QTCurrencyCode
        QTOriginPortCode
        QTOriginPortName
        QTOriginCountryCode
        QTDestinationPortCode
        QTDestinationPortName
        QTDestinationCountryCode
        QTDescriptionOfGoods
        QTTotalAmountInCurrency
        QTItemsAmountInCurrency
        QTChargesAmountInCurrency
        QTTaxAmountInCurrency
        QTTotalValue
        QTTotalAmount
        QTItemsAmount
        QTChargesAmount
        QTTotalTradeDiscount
        QTTotalTradeDiscountInCurrency
        QTTotalPieces
        QTChargeableWeight
        QTWeightUnit
        QTVolumeUnit
        QTVolumeWeightUnit
        QTLengthUnit
        QTLengthPrecision
        QTVolumePrecision
        QTWeightPrecision
        QTVolumeWeightPrecision
        QTAreaPrecision
        QTVolumeWeightFactor
        QTHasFiles
        QTcustomFields {
        name
        value
        internalName
    }

      customFields {
        name
        value
        internalName
      }
    }
  }
}`;
    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    const arr = response?.data?.GetLastComodityListByOperationType?.comodityData;

    const tmpPayload = {
        data: arr,
        milestoneConfig: response.data.GetLastComodityListByOperationType.milestoneConfig,
    };

    return tmpPayload;
};

const fetchMilestonesOperationDataIEN = async () => {
    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query{
  GetLastEntities(Entity:{
    userId:${user.id}
  }){
    milestoneConfig {
        OperationType
        OperationName
        userId
        text
        dataField
        visibleInTable
        visibleInModalHeader
        visibleInMiddle
        visibleInModalFooter
        isMilestone          
        visibleInModalBody
        visibleInModalTotal
        showInFilters
        order
        hidden
      }
    
    entitiesData{
           id
        clientId
        entityType
        name
        createdOn
        address_Street
        address_City
        address_State
        address_ZipCode
        address_Country
        address_Description
        address_ContactName
        address_ContactPhone
        address_ContactFax
        address_ContactEmail
        address_PortCode
        billingAddress_Street
        billingAddress_City
        billingAddress_State
        billingAddress_ZipCode
        billingAddress_Country
        billingAddress_Description
        billingAddress_ContactName
        billingAddress_ContactPhone
        billingAddress_ContactFax
        billingAddress_ContactEmail
        billingAddress_PortCode
        accountNumber
        contactFirstName
        contactLastName
        exporterID
        exporterIDType
        transactionDueDays
        bondReferenceNumber
        creditLimit
        dateOfBirth
        dbClassType
        entityID
        flags
        isBillingClient
        isInactive
        isKnownShipper
        isRemoteUser
        knownShipperExpirationDate
        notes
        phoneExtension
        status
        suretyCode
        usesCollect
        website
        GUID
        customFields {
            name
            value
            internalName
      }
    }
  }
}`; //peticion

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    return {
        data: response?.data?.GetLastEntities?.entitiesData,
        milestoneConfig: response.data.GetLastEntities.milestoneConfig,
    };
};

//-------------------------------------------------------------------------------------------



const fetchMilestonesOperationDataIV = async () => {
    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query{
    GetLastItemDefinitionByOperationType(ItemDefinition: {
      userId:${user.id},
    } ){
      milestoneConfig {
        OperationType
        OperationName
        userId
        text
        dataField
        visibleInTable
        visibleInModalHeader
        visibleInMiddle
        visibleInModalFooter
        isMilestone          
        visibleInModalBody
        visibleInModalTotal
        showInFilters
        order
        hidden
      }
ItemDefinitionData {
            id
          	ClientId
            PartNumber
            SKUs
            GUIDItem
            Customer
            CustomerGUIDCL
            Inactive
        }
    }
  }`; //peticion

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    return {
        data: response?.data?.GetLastItemDefinitionByOperationType?.ItemDefinitionData,
        milestoneConfig: response.data.GetLastItemDefinitionByOperationType.milestoneConfig,
    };
};


const fetchMilestonesOperationDataIN = async () => {
    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query{
    GetLastInvoiceByOperationType(Invoice: {
      userId:${user.id},
    } ){
      milestoneConfig {
        OperationType
        OperationName
        userId
        text
        dataField
        visibleInTable
        visibleInModalHeader
        visibleInMiddle
        visibleInModalFooter
        isMilestone          
        visibleInModalBody
        visibleInModalTotal
        showInFilters
        order
        hidden
      }
        InvoiceData {
        id
        ClientId
        Number
        CreatedOn
        ExchangeRate
        DueDate
        Notes
        Status
        IsPrepaid
        IsPeriodic
        IsPrinted
        IsFiscalPrinted
        HasAttachments
        PaymentTerms
        GUID
        Type
        }
    }
  }`; //peticion

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    return {
        data: response?.data?.GetLastInvoiceByOperationType?.InvoiceData,
        milestoneConfig: response.data.GetLastInvoiceByOperationType.milestoneConfig,
    };
};


const fetchMilestonesOperationDataQT = async () => {
    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query{
    GetLastQuotationByOperationType(Quotation: {
      userId:${user.id},
    } ){
      milestoneConfig {
        OperationType
        OperationName
        userId
        text
        dataField
        visibleInTable
        visibleInModalHeader
        visibleInMiddle
        visibleInModalFooter
        isMilestone          
        visibleInModalBody
        visibleInModalTotal
        showInFilters
        order
        hidden
      }
      QuotationData {
        id
        clientId
        GUID
        Number
        CreatedOn
        LogDate
        ExpirationDate
        CreatedByName
        Version
        IssuedByName
        IssuedByGUID
        ContactName
        ContactGUID
        Status
        Direction
        Service
        Frequency
        IsHazardous
        IsOpenQuote
        PaymentTerms
        ExchangeRate
        CurrencyCode
        OriginPortCode
        OriginPortName
        OriginCountryCode
        DestinationPortCode
        DestinationPortName
        DestinationCountryCode
        DescriptionOfGoods
        TotalAmountInCurrency
        ItemsAmountInCurrency
        ChargesAmountInCurrency
        TaxAmountInCurrency
        TotalValue
        TotalAmount
        TotalTradeDiscount
        TotalTradeDiscountInCurrency
        TotalPieces
        ChargeableWeight
        WeightUnit
        VolumeUnit
        VolumeWeightUnit
        HasFiles
      }
    }
  }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query }),
    }).then((res) => res.json());

    return {
        data: response?.data?.GetLastQuotationByOperationType?.QuotationData,
        milestoneConfig: response.data.GetLastQuotationByOperationType.milestoneConfig,
    };
};











const fetchMilestonesOperationDataBK = async () => {
    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query{
    GetLastBookingByOperationType(Booking: {
      userId:${(user as any).id},
    } ){
      milestoneConfig {
        OperationType
        OperationName
        userId
        text
        dataField
        visibleInTable
        visibleInModalHeader
        visibleInMiddle
        visibleInModalFooter
        isMilestone          
        visibleInModalBody
        visibleInModalTotal
        showInFilters
        order
        hidden
      }
      BookingData {
        id
        clientId
        GUID
        Number
        CreatedOn
        CreatedByName
        Version
        ModeOfTransportCode
        ModeOfTransportDescription
        IssuedByName
        IssuedByGUID
        ShipperName
        ShipperGUID
        ConsigneeName
        ConsigneeGUID
        ImporterName
        ImporterGUID
        BillingClientName
        BillingClientGUID
        DeliverToEntityName
        DeliverToEntityGUID
        OriginPortCode
        OriginPortName
        OriginCountryCode
        DestinationPortCode
        DestinationPortName
        DestinationCountryCode
        Direction
        Service
        BookingStatus
        IsLessThanFullLoad
        IsOnlineBooking
        IsOnline
        IsLiquidated
        ExecutedPlace
        CustomerReferenceNumber
        EstimatedArrivalDate
        EstimatedDepartureDate
        LastDateOfDeparture
        SpottingDate
        PickupDate
        CutoffDate
        TotalPieces
        ChargeableWeight
        TotalWeight
        TotalVolume
        TotalVolumeWeight
        TotalValue
        WeightUnit
        VolumeUnit
        VolumeWeightUnit
        CurrencyCode
        HasFiles
      }
    }
  }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query }),
    }).then((res) => res.json());

    return {
        data: response?.data?.GetLastBookingByOperationType?.BookingData,
        milestoneConfig: response.data.GetLastBookingByOperationType.milestoneConfig,
    };
};
















//-------------------------------------------------------------------------------------------------

function* getMilestonesSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchMilestones);
        yield put(getMilestonesSuccess(response));
    } catch (error) {
        yield put(getMilestonesFail(error));
    }
}

function* getMilestonesOperationDataSaga(data: any) {
    const { Operation } = data.payload;

    if (Operation.OperationType === 'SO') {
        try {
            const response: Promise<any> = yield call(fetchMilestonesOperationDataSO, data);
            if (response) {
                yield put(getMilestonOperationDataSuccess(response));
            } else {
                yield put(getMilestonOperationDataFail('no data found'));
            }
        } catch (error) {
            yield put(getMilestonOperationDataFail(error));
        }
    }
    if (Operation.OperationType === 'SH') {
        try {
            const response: Promise<any> = yield call(
                fetchMilestonesOperationDataSH,
                // data,
            );
            if (response) {
                yield put(getMilestonOperationDataSuccess(response));
            } else {
                yield put(getMilestonOperationDataFail('no data found'));
            }
        } catch (error) {
            yield put(getMilestonOperationDataFail(error));
        }
    }

    if (Operation.OperationType === 'PK') {
        try {
            const response: Promise<any> = yield call(
                fetchMilestonesOperationDataPK,
                // data,
            );
            if (response) {
                yield put(getMilestonOperationDataSuccess(response));
            } else {
                yield put(getMilestonOperationDataFail('no data found'));
            }
        } catch (error) {
            yield put(getMilestonOperationDataFail(error));
        }
    }

    if (Operation.OperationType === 'PO') {
        try {
            const response: Promise<any> = yield call(fetchMilestonesOperationDataPO, data);

            if (response) {
                yield put(getMilestonOperationDataSuccess(response));
            } else {
                yield put(getMilestonOperationDataFail('no data found'));
            }
        } catch (error) {
            yield put(getMilestonOperationDataFail(error));
        }
    }
    if (Operation.OperationType === 'CR') {
        try {
            const response: Promise<any> = yield call(fetchMilestonesOperationDataCR, data);

            if (response) {
                yield put(getMilestonOperationDataSuccess(response));
            } else {
                yield put(getMilestonOperationDataFail('no data found'));
            }
        } catch (error) {
            yield put(getMilestonOperationDataFail(error));
        }
    }
    if (Operation.OperationType === 'WH') {
        try {
            const response: Promise<any> = yield call(fetchMilestonesOperationDataWR, data);

            if (response) {
                yield put(getMilestonOperationDataSuccess(response));
            } else {
                yield put(getMilestonOperationDataFail('no data found'));
            }
        } catch (error) {
            yield put(getMilestonOperationDataFail(error));
        }
    }

    if (Operation.OperationType === 'WI') {
        try {
            const response: Promise<any> = yield call(fetchMilestonesOperationDataWI, data);
            if (response) {
                yield put(getMilestonOperationDataSuccess(response));
            } else {
                yield put(getMilestonOperationDataFail('no data found'));
            }
        } catch (error) {
            yield put(getMilestonOperationDataFail(error));
        }
    }

    if (Operation.OperationType === 'IEN') {
        try {
            const response: Promise<any> = yield call(
                fetchMilestonesOperationDataIEN,
                // data,
            );
            if (response) {
                yield put(getMilestonOperationDataSuccess(response));
            } else {
                yield put(getMilestonOperationDataFail('no data found'));
            }
        } catch (error) {
            yield put(getMilestonOperationDataFail(error));
        }
    }

    if (Operation.OperationType === 'IV') {
        try {
            const response: Promise<any> = yield call(
                fetchMilestonesOperationDataIV,
                // data,
            );
            if (response) {
                yield put(getMilestonOperationDataSuccess(response));
            } else {
                yield put(getMilestonOperationDataFail('no data found'));
            }
        } catch (error) {
            yield put(getMilestonOperationDataFail(error));
        }
    }

    if (Operation.OperationType === 'IN') {
        try {
            const response: Promise<any> = yield call(
                fetchMilestonesOperationDataIN,
                // data,
            );
            if (response) {
                yield put(getMilestonOperationDataSuccess(response));
            } else {
                yield put(getMilestonOperationDataFail('no data found'));
            }
        } catch (error) {
            yield put(getMilestonOperationDataFail(error));
        }
    }

    if (Operation.OperationType === 'QT') {
        try {
            const response: Promise<any> = yield call(
                fetchMilestonesOperationDataQT,
            );
            if (response) {
                yield put(getMilestonOperationDataSuccess(response));
            } else {
                yield put(getMilestonOperationDataFail('no data found'));
            }
        } catch (error) {
            yield put(getMilestonOperationDataFail(error));
        }
    }

    if (Operation.OperationType === 'BK') {
        try {
            const response: Promise<any> = yield call(
                fetchMilestonesOperationDataBK,
            );
            if (response) {
                yield put(getMilestonOperationDataSuccess(response));
            } else {
                yield put(getMilestonOperationDataFail('no data found'));
            }
        } catch (error) {
            yield put(getMilestonOperationDataFail(error));
        }
    }
}

function* updateMilestonesList({ payload: { data } }: any): any {
    const path = url.API_URL;

    const getAuthUser = localStorage.getItem('authUser');
    let user: any;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const milestone_var = Object.values(data);
    milestone_var.forEach((item: any) => {
        item.userId = user.id;
    });

    let dataString = JSON.stringify(milestone_var).replace(/"([^"]+)":/g, '$1:');
    dataString = dataString.replace(/"([^"]+)":/g, '$1:');
    const query = `mutation{
    updateMilestone( Milestone : ${dataString}  )
  }`;

    try {
        const opts = {
            authRequired: false,
            body: {
                query,
            },
            method: 'POST',
        };
        const resp: any = yield call(apiFetch, path, opts);
        const response: Promise<any> = yield call(fetchMilestones);
        yield put(getMilestonesSuccess(response));
    } catch (error) {
        yield put(updateMilestonesFail(error));
    }
}



//--------------------------------------------------------------------------------------------------

export const fetchMilestonesLifeEvents = async () => {
    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `
    query {
        getMilestonesLifeEvents( clientId:${user.EMPRESA_ID} )
        {
            clientId
            order
            name
        }
}`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());
    return response.data.getMilestonesLifeEvents;
};

function* getMilestonesLifeEventsSaga() {
    try {
        const response: Promise<any> = yield call(fetchMilestonesLifeEvents);
        yield put(getMilestonesLifeEventsSuccess(response));
    } catch (error) {
        yield put(getMilestonesLifeEventsFail(error));
    }
}

export const fetchAddMilestonesLifeEvents = async (data: any) => {
    const path = url.API_URL;
    let dataString = JSON.stringify(data).replace(/"([^"]+)":/g, '$1:');
    dataString = dataString.replace(/"([^"]+)":/g, '$1:');
    const query = `
    mutation {
    createMilestonesLifeEvents(MilestoneLifeEvents: ${dataString})
} `;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());
    return response.data.createMilestonesLifeEvents;
};

function* AddMilestonesLifeEventsSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchAddMilestonesLifeEvents, data.payload);
        yield put(addMilestonesLifeEventsSuccess(response));
    } catch (error) {
        yield put(addMilestonesLifeEventsFail(error));
    }
}

function* milestoneSaga() {
    yield takeEvery(MilestoneTypes.GET_MILESTONES, getMilestonesSaga);
    yield takeLatest(MilestoneTypes.UPDATE_MILESTONES, updateMilestonesList);
    yield takeEvery(MilestoneTypes.GET_MILESTONES_OPERATION_DATA, getMilestonesOperationDataSaga);
    yield takeEvery(MilestoneTypes.GET_MILESTONES_LIFE_EVENTS_DATA, getMilestonesLifeEventsSaga);
    yield takeEvery(MilestoneTypes.ADD_MILESTONES_LIFE_EVENTS, AddMilestonesLifeEventsSaga);

}

export default milestoneSaga;
